import React, { useEffect, useState, useCallback } from 'react';
import { api } from '../api';

const CATEGORIES = [
  { value: '', label: 'Të gjithë' },
  { value: 'dhëndri', label: 'Dhëndri' },
  { value: 'nuse', label: 'Nuse' },
  { value: 'të përbashkët', label: 'Së bashku' }
];

export default function GuestListPage() {
  const [guests, setGuests] = useState([]);
  const [tables, setTables] = useState([]);
  const [category, setCategory] = useState('');
  const [search, setSearch] = useState('');
  const [editingId, setEditingId] = useState(null);
  const [newGuest, setNewGuest] = useState({ full_name: '', category: 'të përbashkët', table_id: '' });

  const load = useCallback(async () => {
    const params = {};
    if (category) params.category = category;
    if (search) params.search = search;
    const [g, t] = await Promise.all([api.getGuests(params), api.getTables()]);
    setGuests(g);
    setTables(t);
  }, [category, search]);

  useEffect(() => { load(); }, [load]);

  async function addGuest(e) {
    e.preventDefault();
    if (!newGuest.full_name.trim()) return;
    await api.createGuest({
      full_name: newGuest.full_name.trim(),
      category: newGuest.category,
      table_id: newGuest.table_id || null
    });
    setNewGuest({ full_name: '', category: 'të përbashkët', table_id: '' });
    await load();
  }

  async function updateGuest(id, patch) {
    await api.updateGuest(id, patch);
    await load();
  }

  async function removeGuest(id) {
    if (!window.confirm('Fshi këtë mysafir?')) return;
    await api.deleteGuest(id);
    await load();
  }

  return (
    <div className="guests-page">
      <div className="guests-filters">
        <input
          type="text"
          placeholder="Kërko sipas emrit…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select value={category} onChange={(e) => setCategory(e.target.value)}>
          {CATEGORIES.map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
        <span className="guests-count">{guests.length} mysafirë</span>
      </div>

      <form className="guest-add-form" onSubmit={addGuest}>
        <input
          placeholder="Emri i mysafirit të ri"
          value={newGuest.full_name}
          onChange={(e) => setNewGuest({ ...newGuest, full_name: e.target.value })}
        />
        <select value={newGuest.category} onChange={(e) => setNewGuest({ ...newGuest, category: e.target.value })}>
          {CATEGORIES.filter((c) => c.value).map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
        </select>
        <select value={newGuest.table_id} onChange={(e) => setNewGuest({ ...newGuest, table_id: e.target.value })}>
          <option value="">Pa tavolinë</option>
          {tables.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
        </select>
        <button type="submit">+ Shto</button>
      </form>

      <table className="guests-table">
        <thead>
          <tr>
            <th>Emri</th>
            <th>Kategoria</th>
            <th>Tavolina</th>
            <th>Statusi</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {guests.map((g) => (
            <tr key={g.id}>
              <td>
                {editingId === g.id ? (
                  <input
                    defaultValue={g.full_name}
                    onBlur={(e) => { updateGuest(g.id, { full_name: e.target.value }); setEditingId(null); }}
                    autoFocus
                  />
                ) : (
                  <span onClick={() => setEditingId(g.id)}>{g.full_name}</span>
                )}
              </td>
              <td>
                <select value={g.category} onChange={(e) => updateGuest(g.id, { category: e.target.value })}>
                  {CATEGORIES.filter((c) => c.value).map((c) => <option key={c.value} value={c.value}>{c.label}</option>)}
                </select>
              </td>
              <td>
                <select value={g.table_id || ''} onChange={(e) => updateGuest(g.id, { table_id: e.target.value || null })}>
                  <option value="">Pa tavolinë</option>
                  {tables.map((t) => <option key={t.id} value={t.id}>{t.label}</option>)}
                </select>
              </td>
              <td>
                <select value={g.status} onChange={(e) => updateGuest(g.id, { status: e.target.value })}>
                  <option value="confirmed">Konfirmuar</option>
                  <option value="cancelled">Anuluar</option>
                </select>
              </td>
              <td>
                <button className="danger-small" onClick={() => removeGuest(g.id)}>✕</button>
              </td>
            </tr>
          ))}
          {guests.length === 0 && (
            <tr><td colSpan={5} className="empty-row">Nuk ka mysafirë që përputhen me filtrin.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
